import { FC } from 'react'
import { Slider } from './styles'
import { Handle } from './Handle'
import { HorizontalSliderProps } from './types'

export const HorizontalSlider: FC<HorizontalSliderProps> = ({
  value,
  onChange,
  step,
  min,
  max,
  defaultValue = 0,
  disabled = false,
}) => {
  return (
    <Slider
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      step={step}
      min={min}
      max={max}
      handleRender={origin => <Handle disabled={disabled} style={origin.props.style} />}
      onChange={val => {
        if (typeof val === 'number') {
          onChange?.(val)
        }
      }}
      dots
    />
  )
}
